import {
	type Campaign,
	createClient,
	defaultFelixClientConfig,
	type AddonProduct,
	DeliveryProduct,
	PlanProduct,
	Address,
} from "@services/sdk";
import {
	type ICreditCardDetails,
	type IPaymentDetails,
	SIMTypeEnum,
} from "@servicessdk/models/onboarding-details";
import { atom } from "jotai";

export const clientRefAtom = atom(
	createClient({
		...defaultFelixClientConfig,
		isConnected: true,
		otpRedirectCb: () => {},
	}),
);

export const isHydratedAtom = atom(false);

export const promoCodeAtom = atom<Campaign | null>(null);
export const selectedProductAtom = atom<number | null>(null);

export const productIdAtom = atom<string | null>(null);
export const simTypeAtom = atom<SIMTypeEnum>(SIMTypeEnum.ESIM);

export const keepCurrentNumberAtom = atom<boolean | null>(null);
export const useNewNumberAtom = atom<boolean | null>(null);
export const currentNumberAtom = atom<string | null>(null);

export const emailAtom = atom<string | null>(null);
export const passwordAtom = atom<string | null>(null);
export const externalIdAtom = atom<string | null>(null);

export const creditCardDetailsAtom = atom<ICreditCardDetails>({
	cardholderName: "",
	bin: "",
	lastFour: "",
	expiry: "",
});
export const paymentDetailsAtom = atom<IPaymentDetails>({
	token: "",
	nonce: "",
	deviceData: "{}",
});

export const firstNameAtom = atom<string | null>(null);
export const lastNameAtom = atom<string | null>(null);
export const dobAtom = atom<string | null>(null);
export const residentialAddressAtom = atom<Address>(Address.ConstructEmpty());
export const deliveryAddressAtom = atom<Address>(Address.ConstructEmpty());

export const selectedProductsAtom = atom<{
	[key: string]: AddonProduct;
}>({});

export const deliveryMethodAtom = atom<DeliveryProduct | null>(
	DeliveryProduct.ConstructEmpty(),
);
export const planAtom = atom<PlanProduct>(PlanProduct.ConstructEmpty());
